import { useMemo } from "react";
import { useApiUrl, useCustom } from "@refinedev/core";
import { components } from "@libertify/api-types/api";

type MfaFactorsResponse = components["schemas"]["MfaFactorsResponse"];

// Reads the signed-in user's MFA factor status. `enabled` gates the query so
// it only fires once the user session is known.
export const useMfaFactors = (enabled: boolean) => {
  const apiUrl = useApiUrl();

  const { data, isLoading, isError, refetch } = useCustom<MfaFactorsResponse>({
    url: `${apiUrl}/api/users/me/mfa/factors`,
    method: "get",
    queryOptions: { enabled },
    errorNotification: false,
  });

  const factors = data?.data.factors;
  const noFactorEnabled = useMemo(
    () => factors?.every((factor) => !factor.enabled) ?? false,
    [factors]
  );

  return { factors, noFactorEnabled, isLoading, isError, refetch };
};
